import React from 'react';
import { SignatureSongLyrics } from './SignatureSongLyrics';

export const SignatureSongContentEn: React.FC = () => (
  <>
    <h2>&ldquo;I Think It&apos;s You&rdquo; – our anthem to the missed moment and the second chance</h2>
    <p>
      Some encounters last only seconds—and yet they stay with you for a long time.
    </p>
    <p>
      That&apos;s what <strong>&ldquo;I Think It&apos;s You&rdquo;</strong> is about: that one glance, that brief spark, that mysterious sense that there might have been more. Our signature song captures, in music, what <strong>Missed Connections</strong> is about—attraction, courage for a second try, and the gentle refusal to let a special moment simply drift away.
    </p>
    <p>
      The track is deliberately a little <strong>mysterious, anonymous, and top secret</strong>—like an encrypted signal between two people who noticed each other but haven&apos;t found each other yet. It&apos;s both soundtrack and beacon: a bridge between a fleeting encounter and meeting again when the moment is right.
    </p>
    <p>
      At our <strong>events and singles nights at Crime Club</strong>, <strong>&ldquo;I Think It&apos;s You&rdquo;</strong> really comes into its own—not everyone can or wants to speak up right away. Sometimes it takes the right beat afterward. Then the song becomes an anthem for everyone who felt a spark, caught each other&apos;s eye—and might still want to connect once the dust settles.
    </p>
    <p>
      <strong>&ldquo;I Think It&apos;s You&rdquo;</strong> is more than a song.<br />
      It&apos;s a feeling. A code. A second chance in musical form.
    </p>

    <SignatureSongLyrics
      listenCaption={'“I Think It\u2019s You” – listen'}
      audioUnsupportedFallback="Your browser does not support embedded audio playback."
    />
  </>
);
